import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoaderStatus: (state, action) => {
      state.open = action.payload.open;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoaderStatus } = loaderSlice.actions;

export const getLoaderStatus = state => state.loader.open;

export default loaderSlice.reducer;
